import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LogoSVG, LogoImage } from "./logo.styles";
import LogoOnWhite from "@topi/ui/assets/svgs/brand/topi-logo-on-white.svg?react";
import LogoOnBlack from "@topi/ui/assets/svgs/brand/topi-logo-on-black.svg?react";
import LogoOnBlue from "@topi/ui/assets/svgs/brand/topi-logo-on-blue.svg?react";
import LogoOnPink from "@topi/ui/assets/svgs/brand/topi-logo-on-pink.svg?react";
import { isTopiBranding } from "@topi/ui/styles/tokens/utils";

export interface LogoProps {
  className?: string;
  variant?: "on-white" | "on-black" | "on-blue" | "on-pink";
  size?: "s" | "m";
  logoURL?: string;
}

export const Logo: FC<LogoProps> = ({
  className,
  variant = "on-white",
  size = "m",
  logoURL,
}) => {
  const { t } = useTranslation();

  const logoVariant = useMemo(() => {
    switch (variant) {
      case "on-white":
        return LogoOnWhite;
      case "on-black":
        return LogoOnBlack;
      case "on-blue":
        return LogoOnBlue;
      case "on-pink":
        return LogoOnPink;
      default:
        return LogoOnWhite;
    }
  }, [variant]);

  if (logoURL) {
    return (
      <LogoImage
        className={className}
        $isTopiLogo={isTopiBranding(logoURL)}
        src={logoURL}
        alt={t("branding.companyLogoAltText")}
        $size={size}
      />
    );
  }

  return <LogoSVG className={className} $size={size} as={logoVariant} />;
};
